<template>
  <v-card>
    <v-toolbar color="blue-grey white--text">
      <!-- <v-icon>contacts</v-icon> -->
      <v-toolbar-title class="white--text">วิชา</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-title class="subheading white--text"></v-toolbar-title>
    </v-toolbar>
    <v-card-title>
      <v-text-field
        v-model="pagination.q"
        append-icon="search"
        label="ค้าหา รหัส, ชื่อวิชา"
        single-line
        hide-details
      ></v-text-field>
      <v-spacer></v-spacer>
      <v-tooltip left>
        <v-btn color="teal" slot="activator" dark fab @click="addItem()">
          <v-icon>playlist_add</v-icon>
        </v-btn>
        <span>เพิ่มประเภทบุคคล</span>
      </v-tooltip>
    </v-card-title>
    <v-data-table
      :loading="loading"
      :headers="headers"
      :items="items"
      :total-items="pagination.totalItems"
      :pagination.sync="pagination"
    >
      <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
      <template slot="items" slot-scope="props">
        <td class="text-xs-center">{{ ((pagination.page - 1) * pagination.rowsPerPage) + props.index + 1 }}</td>
        <td class="text-xs-left">{{ props.item.code }}</td>
        <td class="text-xs-left">{{ props.item.nameTh }}</td>
        <td class="text-xs-left">{{ props.item.nameEn }}</td>
        <td class="text-xs-left">{{ props.item.credit }}</td>
        <td class="text-xs-left">{{ props.item.subjectType }}</td>
        <td class="text-xs-left">{{ props.item.category }}</td>
        <td class="justify-center layout">
          <v-tooltip left>
            <v-btn icon class="mx-0" slot="activator" @click="viewItem(props.item)">
              <v-icon color="teal">pageview</v-icon>
            </v-btn>
            <span>ดูข้อมูล</span>
          </v-tooltip>

          <v-tooltip left>
            <v-btn icon class="mx-0" slot="activator" @click="deleteItem(props.item)">
              <v-icon color="pink">delete</v-icon>
            </v-btn>
            <span>ลบข้อมูล</span>
          </v-tooltip>
        </td>
      </template>
      <v-alert slot="no-results" :value="true" color="error" icon="warning">
        Your search for "{{ pagination.q }}" found no results.
      </v-alert>
    </v-data-table>
    <template>
      <component :is="formDialog" :dialog="dialog" :item="selectedItem" :title="title" @dialog="dialog = $event"></component>
    </template>
  </v-card>
</template>


<script>
import { mapGetters } from 'vuex'
import swal from 'sweetalert2'
import SubjectFormDialog from './formDialog.vue'

export default {
  components: {
  SubjectFormDialog
},
  data () {
    return {
      dialog: false,
      title: null,
      formDialog: null,
      loading: false,
      headers: [
        { text: '#', sortable: false, align: 'center' },
        { text: 'รหัสวิชา', value: 'code', align: 'left', sortable: true },
        { text: 'ชื่อวิชา (ไทย)', value: 'nameTh', align: 'left', sortable: false },
        { text: 'ชื่อวิชา (อังกฤษ)', value: 'nameEn', align: 'left', sortable: false },
        { text: 'หน่วยกิต', value: 'credit', align: 'left', sortable: false },
        { text: 'กลุ่มวิชา', value: 'subjectType', align: 'left', sortable: false },
        { text: 'หมวด/สาระวิชา', value: 'category', align: 'left', sortable: false },
        { sortable: false }
      ],
      pagination: {
        q: '',
        sortBy: 'code',
        page: 1,
        rowsPerPage: 10,
        descending: false,
        totalItems: 0
      },
      items: [],
      selectedItem: {},
    }
  },
  mounted () {
    this.reload()
  },
  methods: {
    addItem () {
      this.title = 'เพิ่มวิชา'
      this.formDialog = 'subject-form-dialog'
      setTimeout(()=>{this.dialog = true}, 300)
    },
    viewItem (item) {
      this.selectedItem = item
      this.title = 'แก้ไขวิชา'
      this.formDialog = 'subject-form-dialog'
      setTimeout(()=>{this.dialog = true}, 300)
    },
    deleteItem (item) {
      swal({
        title: 'คุณแน่ใจ?',
        text: "คุณจะไม่สามารถเรียกคืนข้อมูลได้อีก!",
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'ยกเลิก',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ใช่, ฉันต้องการลบข้อมูลนี้!'
      }).then((result) => {
        console.log('swal', result.value)
        if (result.value) {
          this.$store.dispatch('subject/delete', item)
            .then((response) => {
                console.log('reload:', response )
                this.reload()
              }).catch((error) => {
                swal('Error!', error.message, 'error')
              })
          swal(
            'ลบรายการ!',
            'คุณได้ทำการลบรายการเรียบร้อยแล้ว',
            'success'
          )
        }
      })
    },
    reload () {
      this.loading = true
      this.$store.dispatch('subject/loadItemsAsPage', this.pagination)
        .then((response) => {
          console.log('reload:', response )
          this.pagination.totalItems = response.data.totalItems
          this.items = response.data.items
          this.loading = false
        }).catch((error) => {
          this.loading = false
          swal('Error!', error.message, 'error')
        })
    },
    reset () {
      this.selectedItem = {}
    }
  },
  watch: {
    'pagination.rowsPerPage' () {
      this.reload()
    },
    'pagination.q' () {
      this.reload()
    },
    'pagination.page' () {
      this.reload()
    },
    'pagination.descending' () {
      this.reload()
    },
    dialog (val) {
      if(!val) {
        setTimeout(()=>{
          this.reset()
          this.formDialog = null
        }, 300)
        this.reload()
      }

    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/settings/subject/index.vue